import {Card, Search} from 'platform/components';

import {useState} from 'react';
import {useSelector} from 'react-redux';

import {useEditTopMakesMutation, useGetTopMakesQuery} from '@dms/api/vehicle';
import {testIds} from '@dms/routes';
import {handleApiError} from '@dms/shared';
import {selectVehicleMakes} from '@dms/teas';

import {TopMakesList} from './TopMakesList';

export function TopMakes() {
  const {data: topMakesData} = useGetTopMakesQuery();
  const topMakes = topMakesData ?? [];
  // NOTE: For now it's only for VEHICLETYPE_PASSENGER_CAR type
  const makeOptions = useSelector(selectVehicleMakes('VEHICLETYPE_PASSENGER_CAR'));
  const [search, setSearch] = useState<string | null>(null);
  const [editTopMakesMutation] = useEditTopMakesMutation();

  const filteredOptions = makeOptions
    .map((option) => ({
      ...option,
      loading: false,
      checked: topMakes.some((make) => make.code === option.value),
    }))
    .filter((make) => (search ? make?.label?.toLowerCase()?.includes(search.toLowerCase()) : true));

  const handleRowToggle = (makeCode: string) => {
    const topMakesUpdated = topMakes.some((make) => make.code === makeCode)
      ? topMakes.filter((make) => make.code !== makeCode)
      : [...topMakes, {code: makeCode}];

    editTopMakesMutation({
      editTopMakesRequestBody: {makes: topMakesUpdated?.map((make) => make.code) ?? []},
    })
      .unwrap()
      .catch(handleApiError);
  };

  return (
    <Card>
      <Search
        value={search}
        onChange={setSearch}
        data-testid={testIds.settings.vehicleTopMakes('searchTopMakes')}
      />
      <TopMakesList makeOptions={filteredOptions} handleRowToggle={handleRowToggle} />
    </Card>
  );
}
